export default {
  brokenLinks: state => state.brokenLinks
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/repair-links/getters.js